import React, { useCallback, useContext } from 'react';
import c from 'classnames';
import FallbackEditor from '../../DaEditorWrapper/Fallback';
import { CommentEditorContext, EditorContext } from '../context';
import s from './CommentFallbackEditor.scss';
const CommentFallbackEditor = ({ initialContent , onChange , className  })=>{
    const { setIsFallbackEmpty  } = useContext(CommentEditorContext);
    const { overrideEditorState , props: { onEditorInit  }  } = useContext(EditorContext);
    const handleChange = useCallback((editorState)=>{
        setIsFallbackEmpty(editorState.isEmpty);
        // Because we're faking the editor state inside our fallback editor, we need to override the editor
        // state in the context.
        overrideEditorState(editorState);
        onChange && onChange(editorState);
    }, [
        onChange,
        setIsFallbackEmpty,
        overrideEditorState
    ]);
    return /*#__PURE__*/ React.createElement(FallbackEditor, {
        className: c(s['root'], className),
        value: initialContent,
        onChange: handleChange,
        onReady: onEditorInit
    });
};
CommentFallbackEditor.displayName = 'CommentFallbackEditor';
export default CommentFallbackEditor;
